import { API_LOANS_URL } from 'config'
import { apiCall } from './base'

export const getProvince = (type = '32') =>
  apiCall(`v3/province/${type}`, {
    baseURL: API_LOANS_URL,
    method: 'GET',
    withCredentials: true,
    immediately: true
  }).then((res) => {
    const arr = Array.from(Object.entries(res.data), ([key, val]) => ({
      name: val,
      key
    }))

    return arr
  })

export const getLocality = (province) =>
  apiCall(`v3/locality/${province}`, {
    baseURL: API_LOANS_URL,
    method: 'GET',
    withCredentials: true,
    immediately: true
  }).then((res) => {
    const arr = Array.from(Object.entries(res.data), ([key, val]) => ({
      name: val,
      key
    }))

    return arr
  })

export const updateAddress = (data) => {
  apiCall(`v3/address`, {
    baseURL: API_LOANS_URL,
    method: 'POST',
    withCredentials: true,
    immediately: true,
    data
  })
}
